import React from "react";
import type { BentoQuoteBlockData } from "../../../types/content";
import styles from "./QuoteBlock.module.css";

export interface BentoQuoteBlockProps {
  block: BentoQuoteBlockData;
  className?: string;
}

/**
 * Bento Quote Block component - title/subtitle on colored background
 * Used for stats, quotes, and breakout sections in bento grids
 * Fills 100% width and height of its container
 */
export const BentoQuoteBlock: React.FC<BentoQuoteBlockProps> = ({
  block,
  className,
}) => {
  const {
    title,
    subtitle,
    backgroundColor,
    textColor,
    borderRadius = "none",
  } = block;

  if (!title) {
    return null;
  }

  const containerClasses = [
    styles.block,
    styles[`radius-${borderRadius}`],
    className,
  ]
    .filter(Boolean)
    .join(" ");

  // Inline styles for dynamic colors
  const containerStyle: React.CSSProperties = {
    backgroundColor: backgroundColor || "#212f23",
    color: textColor || "#c2ca97",
  };

  return (
    <div
      className={containerClasses}
      style={containerStyle}
      data-component="bento-quote-block"
      data-radius={borderRadius}
    >
      <div className={styles.content}>
        <p className={styles.title}>{title}</p>
        {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
      </div>
    </div>
  );
};

export default BentoQuoteBlock;
